export default "__VITE_ASSET__6cb3e06e__"